/** @jsxImportSource @emotion/react */
import type {
    GetStaticPropsContext,
    InferGetStaticPropsType,
    NextPage,
    PreviewData,
} from "next";
import { ParsedUrlQuery } from "querystring";

import { Divider } from "@/ui/atoms/divider";
import { CareersBenefits } from "@/ui/organisms/careers_benefits";
import { CareersHero } from "@/ui/organisms/careers_hero";
import { CareersOverview } from "@/ui/organisms/careers_overview";
import { CareersRoles } from "@/ui/organisms/careers_roles";
import { CareersWork } from "@/ui/organisms/careers_work";

import { generatePageLevelProps } from "@/util/data_util";
import { generateLegacyPreFooterData } from "@/util/strapi_data_util";
import { getCareersPage, getGlobals } from "@/util/strapi_util";

export const getStaticProps = async ({
    preview: previewMode = false,
}: GetStaticPropsContext<ParsedUrlQuery, PreviewData>) => {
    const slug = "careers";

    const globalsData = await getGlobals(previewMode);
    const pageData = await getCareersPage(previewMode);

    return {
        props: {
            ...generatePageLevelProps({ path: `/${slug}`, previewMode, slug }),
            ...generateLegacyPreFooterData(
                globalsData,
                pageData.Pre_Footer,
                false,
            ),
            globalsData,
            pageData,
        },
    };
};

type PageProps = InferGetStaticPropsType<typeof getStaticProps>;

const Page: NextPage<PageProps> = (props) => {
    /**
     * Rendering
     */
    return (
        <>
            <CareersHero {...props.pageData.Hero} />

            <Divider
                marginBottom="CareersContainerMargin"
                marginTop="CareersContainerMargin"
            />

            <CareersOverview {...props.pageData} />

            <Divider
                marginBottom="CareersContainerMargin"
                marginTop="CareersContainerMargin"
            />

            <CareersWork {...props.pageData} />

            <CareersBenefits {...props.pageData} />

            <Divider />

            <CareersRoles {...props.pageData} />
        </>
    );
};

export default Page;
